// extracted by mini-css-extract-plugin
export default {"loader":"splashScreen_loader__A0dno"};